module.exports = __webpack_public_path__ + "static/media/Correct_GreenBubble.6adb1232.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/rlgl/Intro/svg/Correct_GreenBubble.svg
// module id = 427
// module chunks = 0